<template>
  <div>
    <v-alert
      color="blue"
      text
      type="info"
    >{{ $t("personal.data.info") }}</v-alert>
    <v-row>
      <v-col cols="12" sm="5">
        <v-text-field
          v-model="investigator.person.preferred_name.given_name"
          :label="$t('form.name')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="7">
        <v-text-field
          v-model="investigator.person.preferred_name.family_name"
          :label="$t('form.surname')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="5">
        <v-text-field
          v-model="investigator.person.alt_name.given_name"
          :label="$t('form.nameAlt')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="7">
        <v-text-field
          v-model="investigator.person.alt_name.family_name"
          :label="$t('form.surnameAlt')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="investigator.person.email[0]"
          :label="$t('form.email')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          :value="
            investigator.person.id_number.type.toLocaleUpperCase() +
              ' - ' +
              investigator.person.id_number.value
          "
          :label="$t('form.dni')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="investigator.person.number"
          :label="$t('form.mobile')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          :label="$t('form.gender')"
          :value="$t('form.' + investigator.person.gender)"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :value="personsInCharge.map(p => p.name)"
          :label="$t('form.incharge')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="isInternal">
      <v-col cols="12">
        <v-text-field
          :value="
            investigator.person.research_areas.map(function(item) {
              return item.name[$i18n.locale];
            })
          "
          :label="$t('form.publication.research_areas')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import investigatorData from "../../mixins/investigator_data";
import investigator_model from "../../mixins/model_utils/investigator_model";

export default {
  props: {
    person: Number
  },
  mixins: [investigatorData,investigator_model],

  data: () => ({
    investigator: {
      account: {},
      affiliations: {
        active: [],
        expired: []
      }
    }
  }),

  methods: {
    getInvestigator() {
      const path = this.$store.state.endpoint + "/person/" + this.person;
      axios
        .get(path)
        .then(response => {
          this.investigator.person = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAffiliations() {
      const path =
        this.$store.state.endpoint + "/academic/person/" + this.person;
      axios
        .get(path)
        .then(response => {
          let current = new Date().toISOString().substr(0, 10);
          response.data.forEach(affiliation => {
            if (affiliation.end_date < current) {
              this.investigator.affiliations.expired.push(affiliation);
            } else {
              this.investigator.affiliations.active.push(affiliation);
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getNameOrganization(id) {
      let organization = this.organizations.find(
        organization => organization.id === id
      );
      if (organization !== undefined) {
        return organization.name;
      }
      return "";
    }
  },

  created() {
    this.getInvestigatorAndPersonsInCharge(
      this.$store.state.endpoint + "/person/" + this.person
    );
    if(this.$store.getters.isInternal){
      this.getAffiliations();
      this.getOrganizations();
    }
    this.getInvestigator();
  }

};
</script>

<style scoped>
.disable-events {
  pointer-events: none
}
</style>
